export default "__VITE_ASSET__DX50T$dm__"